export const ENCRYPTION_KEY = 'mrsoftyruday1234';
export const IV_KEY = 'mrsoftyruday1234';
export const IMAGE_PATH= `https://vyapar-data.s3.ap-south-1.amazonaws.com`